export const parseAmount = (amount: string | undefined): number =>
    amount ? +amount.replace(/[^\d]/g, '') : 0;
